import { render } from "./CheckboxWithLabel.vue?vue&type=template&id=19510dbb"
import script from "./CheckboxWithLabel.vue?vue&type=script&lang=js"
export * from "./CheckboxWithLabel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CheckboxWithLabel.vue"]])

export default __exports__